import React,{ Fragment, useEffect,useState } from 'react';
import { batch, useSelector, useDispatch } from 'react-redux';
import { Link } from "react-router-dom";
import axios from 'axios';
import moment from 'moment';
import Linkify from 'react-linkify';

import cover_init from '../../../images/cover_init.jpg';
import cover_hunter from '../../../images/cover_hunter.jpg';
import cover_market from '../../../images/cover_market.jpg';
import cover_consumption from '../../../images/cover_consumption.jpg';
import markerDetail from '../../../images/marker-detail.svg';
import filterAction from '../../actions/filterAction';

const getSpeciesStudyId = ({ speciesStudyList, s }) => {
  let i = speciesStudyList.length - 1;
  let d = s;
  while (i >= 0) {
    if (speciesStudyList[i].scientificName === s) {
      d = speciesStudyList[i].studyId;
      break;
    }
    i--;
  }

  return d;
};

const getCountryStudyId = ({ countryStudyList, s }) => {
  let i = countryStudyList.length - 1;
  let d = s;
  while (i >= 0) {
    if (countryStudyList[i].country === s) {
      d = countryStudyList[i].studyId;
      break;
    }
    i--;
  }

  return d;
};

const SpeciesLinks = ({ studyId, scientificNames }) => {
  const setApp = useDispatch();
  const { allMarkers } = useSelector(s => s.markers);
  const { speciesStudyList } = useSelector(s => s.species);

  if (!speciesStudyList) {
    return null;
  }

  return (
    <>
      {
        scientificNames.map((scientificName, index) => {
          const data = speciesStudyList.find(d => (
            d.scientificName === scientificName
          ));

          return (
            <span key={scientificName}>
              {
                index === 0 ? '' : ', '
              }
              <Link
                to={`/species/${data.scientificNameSlug}`}
                onClick={()=>{
                  batch(()=>{
                    setApp({
                      type: '_STUDY_DETAIL',
                      payload: ['prevStudyID', studyId]
                    });

                    setApp(filterAction({
                      allMarkers,
                      sid: data.studyId,
                      label:`Species (<strong>${scientificName}</strong>)`,
                      filterSlug: data.scientificNameSlug
                    }));
                  });
                }}
              >
                {scientificName}
              </Link>
            </span>
          )
        })
      }
    </>
  );
};

const CountryLinks = (d) => {
  const setApp = useDispatch()
  const { allMarkers } = useSelector(s => s.markers)
  const { countryStudyList } = useSelector(s => s.country)
  const s = d.data;

  if (!countryStudyList) {
    return null;
  }

  return (
    <>
      {
        s.map((dt, i)=>{
          const data = countryStudyList.find(d => (
            d.country === dt.country
          ));
          return (
            <span key={i}>
              {i > 0 ? ', ' : ''}
              <Link
                to={`/countries/${data.countrySlug}`}
                onClick={() => {
                  batch(()=>{
                    setApp({
                      type: '_STUDY_DETAIL',
                      payload: ['prevStudyID', d.studyId]
                    });
                    setApp(filterAction({
                      allMarkers,
                      sid: data.studyId,
                      label: `Country (<b>${dt.country}</b>)`,
                      filterSlug: data.countrySlug
                    }));
                  });
                }}
              >
                {dt.country}
              </Link>
              {' '}
              {
                dt.siteIds
                  ? (
                      <span style={{opacity:0.7}}>
                        {'('}
                        {
                          dt.siteIds.map((siteId, index) => (
                            <Fragment key={siteId}>
                              {index === 0 ? '' : ', '}
                              {`Site ${siteId}`}
                            </Fragment>
                          ))
                        }
                        {')'}
                      </span>
                    )
                  : null
              }
            </span>
          )
        })
      }
    </>
  );
};

const StudyDetail = () => {
  const setApp = useDispatch();
  const {
    studyID,
    studyTitle,
    studySite,
    studyTotal
  } = useSelector(s => s.studyDetail);
  const { allStudies } = useSelector(s => s.allStudies);
  const { sbBlock } = useSelector(state => state.sb);
  const { first_name } = useSelector(s => s.auth);
  const { label, filterSlug } = useSelector(s => s.filtered);
  const [show,setShow] = useState(false);
  const [data,setData] = useState(!1);
  const [pubs, setPubs] = useState(!1);
  const [authors, setAuthors] = useState(!1)
  const [sites, setSites] = useState(!1);
  const [siteTypes, setSiteTypes] = useState(!1);
  const [wm,setWm] = useState(!1);
  const [isMultiple, setIsMultiple] = useState(false);
  const [multipleData, setMultipleData] = useState(false);

  const fetchStudyById = async () => {
    try {
      const r = await axios.get(
        `/studydetail?id=${studyID[0]}&t=${new Date().getTime()}`
      );

      setAuthors(r.data.author);
      setData(r.data);
      setSites(r.data.location_JSON);
      setSiteTypes(r.data.siteType);
      setPubs(r.data.publication_JSON);
      setWm(r.data.scientificName);
      setShow(1);
      setApp({
        type: '_STUDY_DETAIL',
        payload: ['studyDetailData', r.data]
      });
    } catch (_) {
      if (window.location.href.indexOf('study/') > -1) {
        window.location.href = '/';
      }
    }
  };

  useEffect(() => {
    setShow(false);
    setData(false);
    if (studyID) {
      if (studyID.length > 1) {
        setIsMultiple(
          allStudies.filter(v => studyID.includes(v.studyId))
        );
        setMultipleData(studyID);
        setShow(true);
      } else {
        if (studyID[0] > 0) {
          fetchStudyById();
        }
      }
    }

    return () => {
      setShow(false);
      setData(false);
      setIsMultiple(false)
      setApp({
        type: '_STUDY_DETAIL',
        payload: ['studyDetailData', null]
      });
    }
  }, [studyID])

  if (!studyID || !studyID?.length || studyID[0] < 1) {
    return null;
  }

  return (
    <div id="p-detail" className="p-detail sb-body-inner">
      <Link to={
        sbBlock === 'init'
          ? '/'
          : (
              `/${sbBlock.toLowerCase()}${
                filterSlug ? `/${filterSlug}` : ''
              }`
            )
        }
      >
        <button
          className="btn btn-border btn-gb"
          onClick={() => {
            batch(()=>{
              if (!isMultiple) {
                setApp({
                  type: '_STUDY_DETAIL',
                  payload: ['studyTitle', null]
                });
                setApp({
                  type: '_STUDY_DETAIL',
                  payload: ['studyID', multipleData]
                });
                setApp({
                  type: '_STUDY_DETAIL',
                  payload: ['prevStudyID', null]
                });
              } else {
                setApp({ type: '_STUDY_DETAIL', payload: ['studyID', null] });
                setApp({ type: '_STUDY_DETAIL', payload: ['studySite', null] });
                setMultipleData(!1);
              }

              if (!label) {
                setApp({ type: '_MARKERS_INIT' });
              }
            });
          }}
        >
          <i className="fa fa-chevron-left"></i>&nbsp;&nbsp;Go Back
        </button>
      </Link>

      {
        !isMultiple ? (
          <div
            id="image-header"
            style={{
              background:`#000${
                data.surveyType
                  ? (
                      ` url(${
                        data.surveyType === 'Market'
                          ? cover_market
                          : (
                              data.surveyType === 'Harvest'
                                ? cover_hunter
                                : cover_consumption
                            )
                      }) center center`
                    )
                  : ` url(${cover_init})`
              }`
            }}
          >
            <div/>
            <h5 style={{marginBottom: 25}}>
              {data ? data.title : studyTitle}
            </h5>
          </div>
        )
        :
        (
          <>
            <div style={{ display:'table', marginTop: 45 }}>
              <div style={{
                display: 'table-cell',
                verticalAlign: 'top',
                paddingRight: 10
              }}>
                <img
                  src={markerDetail}
                  alt=""
                  style={{ marginTop: 3, width: 28 }}
                />
              </div>
              <div style={{ display: 'table-cell', verticalAlign: 'top' }}>
                <p>
                  Location: {studySite[0]}
                  <br/>
                  <b>{studySite[1]}</b>
                </p>
              </div>
            </div>
            <p
              style={{
                borderLeft: '3px solid rgb(211, 150, 0)',
                background: 'rgba(211, 150, 0, 0.1)',
                padding: '5px 10px'
              }}
              dangerouslySetInnerHTML={{
                __html:`There are <b>${studyTotal} studies</b> in this location`
              }}
            />
          </>
        )
      }

      {
        !show && (
          <div className="lds-dual-ring2"/>
        )
      }

      {
        isMultiple && (
          <div className="sb-project-list">
            <ul className="list-unstyled">
            {
              isMultiple.map(d => {
                return (
                  <li role="presentation" key={d.studyId}>
                    <Link
                      to={`/study/${d.studyId}`}
                      onClick={() => {
                        batch(() => {
                          setApp({
                            type: '_STUDY_DETAIL',
                            payload: ['studyID', [d.studyId]]
                          });
                          setApp({
                            type: '_STUDY_DETAIL',
                            payload: ['studyTitle', d.title]
                          });
                        });
                      }}
                    >{d.title}</Link>
                  </li>
                )

              })
            }
            </ul>
          </div>
        )
      }

      {
        data ? (
          <div className="d-meta">
            <div className="d-desc d-desc-2">
              <div className="alert alert-warning jittered-warning">
                {[
                  'Site locations have been jittered by 40km',
                  'to preserve the anonymity of sites.'
                ].join(' ')} 
              </div>
              {
                data.doi && (
                  <p>
                    <a
                       style={{
                        opacity: 0.5,
                        marginBottom: 20,
                        display: 'block',
                        fontWeight: 600,
                        color: '#000',
                        marginTop: -5,
                        fontSize: 13,
                        letterSpacing: '1px',
                      }} 
                      href={`https://doi.org/${data.doi}`}
                      target="_blank"
                    >
                      {data.doi}
                    </a>
                  </p>
                )
              }
              <div className="d-meta-block">
                <h5>Description</h5>
                <p>{data.description}</p>
              </div>
              <div className="d-meta-block">
                <h5>Author(s)</h5>
                <p>
                  {
                    authors?.length
                      ? (
                          authors.map((author, index) => (  
                            <span key={author}>
                              {index > 0 ? ', ' : ''}
                              {author}
                            </span>
                          ))
                        )
                      
                      : '-'
                  }
                </p>
              </div>
              {
                data.startDate
                  ? (
                      <div className="d-meta-block">
                        <h5>LENGTH OF STUDY</h5>
                        <p>
                          {moment(data.startDate).format('D MMMM YYYY')}
                          {' - '}
                          {moment(data.endDate).format('D MMMM YYYY')}
                        </p>
                      </div>
                    )
                  : null
              }
              <div
                style={{
                  background: [
                    'linear-gradient(45deg, ',
                    '#f9f9f9, rgba(210,149,1,0.14),rgba(245,239,227,0.3)',
                    ')'
                  ].join('')
                }}
                className="study-detail-block study-detail-block-2"
              >
                <h4>Download dataset</h4>
                <div className="d-meta-block">
                  {
                    first_name ? (
                      <p>
                        <button
                          style={{ width: '100%' }}
                          className="btn btn-primary"
                          onClick={() => {
                            batch(() => {
                              setApp({
                                type: '_POPUP',
                                payload: ['popup', 'Permission']
                              });
                              if (!studyTitle) {
                                setApp({
                                  type: '_STUDY_DETAIL',
                                  payload: ['studyTitle', data.title]
                                });
                              }
                            });
                          }}
                        >
                          <i className="fa fa-download" /> Download here
                        </button>
                      </p>
                    ) : (
                      <>
                        <p>
                          <i className="fa fa-info-circle"/>
                          {' You need to login to download this dataset'}
                          <br/>
                          <i className="fa fa-long-arrow-right"/>
                          {' '}
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              setApp({
                                type: '_POPUP',
                                payload: ['popup', 'Login']
                              });
                            }}
                            role="presentation"
                          >
                            {'Click '}
                            <strong style={{ textDecoration: 'underline' }}>
                              here to login
                            </strong>
                          </a>
                          {' or '}
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              setApp({
                                type: '_POPUP',
                                payload: ['popup', 'Register']
                              });
                            }}
                            role="presentation"
                          >
                            <strong style={{ textDecoration: 'underline' }}>
                              here to sign up
                            </strong>
                          </a>
                        </p>
                      </>
                    )
                  }
                </div>
              </div>

              <div className="study-detail-block">
                <h4>Study overview</h4>
                <div className="d-meta-block">
                  <h5>Survey type</h5>
                  <p>{data.surveyType}</p>
                </div>
                <div className="d-meta-block">
                  <h5>Survey method</h5>
                  {
                    data.surveyMethod_JSON
                      ? (
                          <ul>
                            {
                              data.surveyMethod_JSON.map(sm => (
                                <li key={sm.method}>
                                  {sm.method}
                                  {
                                    sm.description && (
                                      <>
                                        <br/>
                                        <span style={{
                                          opacity: 0.65
                                        }}>
                                          {sm.description}
                                        </span>
                                      </>
                                    )
                                  }
                                </li>
                              ))
                            }
                          </ul>
                        )
                      : <p>-</p>
                  }
                </div>
                <div className="d-meta-block">
                  <h5>Survey level</h5>
                  {
                    data.surveyLevel
                      ? (
                          <ul>
                            {
                              data.surveyLevel.map(sl => (
                                <li key={sl}>
                                  {sl}
                                </li>
                              ))
                            }
                          </ul>
                        )
                      : <p>-</p>
                  }
                </div>
                <div className="d-meta-block">
                  <h5>Actor selection method</h5>
                  {
                    data.actorSelectionMethod_JSON
                      ? (
                          <ul>
                            {
                              data.actorSelectionMethod_JSON.map(asm => (
                                <li key={asm.code}>
                                  {asm.description}
                                </li>
                              ))
                            }
                          </ul>
                        )
                      : <p>-</p>
                  }
                </div>
                <div className="d-meta-block">
                  <h5>Data resolution</h5>
                  {
                    data.dataResolution_JSON
                      ? (
                          <ul>
                            {
                              data.dataResolution_JSON.map(dr => (
                                <li key={dr.code}>
                                  {dr.description}
                                </li>
                              ))
                            }
                          </ul>
                        )
                      : <p>-</p>
                  }
                </div>
              </div>

              <div className="study-detail-block study-detail-block-2">
                <h4>Site information</h4>
                {

                  <div className="d-meta-block">
                    <h5>
                      Location{!sites ? '' : (sites.length > 1 ? 's' : '')}
                    </h5>
                    <p>
                      {
                        !sites ? null : (
                          <CountryLinks data={sites} studyId={studyID} />
                        )
                      }
                    </p>
                  </div>

                }
                {
                  !siteTypes.length ? null : (
                    <div className="d-meta-block">
                      <h5>Site type</h5>
                      {
                        siteTypes
                          ? (
                              <ul>
                                {
                                  siteTypes.map(siteType => (
                                    <li key={siteType}>
                                      {siteType}
                                    </li>
                                  ))
                                }
                              </ul>
                            )
                          : <p>-</p>
                      }
                    </div>
                  )
                }
              </div>
              {
                !wm ? null : (
                  <div className="study-detail-block">
                    <h4>Wildmeat overview</h4>
                    <div className="d-meta-block">
                      <h5>Species</h5>
                      <p>
                        {
                          !wm.length
                            ? '-'
                            : (
                                <SpeciesLinks
                                  scientificNames={wm}
                                  studyId={studyID}
                                />
                              )
                        }
                      </p>
                    </div>
                    <div className="d-meta-block">
                      <h5>Mass method</h5>
                      {
                        data.massMethod
                          ? (
                              <ul>
                                {
                                  data.massMethod.map(mm => (
                                    <li key={mm}>
                                      {mm}
                                    </li>
                                  ))
                                }
                              </ul>
                            )
                          : <p>-</p>
                      }
                    </div>
                  </div>
                )
              }

              <div className="study-detail-block study-detail-block-2 ">
                <h4>Publication</h4>
                <div className="d-meta-block">
                  <h5>Publication arising from this dataset</h5>
                  <ul>
                    {
                      !pubs
                        ? null
                        : (
                            pubs.map(d => {
                              return (
                                <li key={d.id}>
                                  <span>{d.title}<br/></span>
                                  <small>
                                    <Linkify
                                      componentDecorator={(
                                        decoratedHref,
                                        decoratedText,
                                        key
                                      ) => (
                                        <a
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          href={decoratedHref}
                                          key={key}
                                        >
                                          {decoratedText}
                                        </a>
                                      )}
                                    >
                                      {d.bibliographicCitation}
                                    </Linkify>
                                  </small>
                                </li>
                          )
                        })
                      )
                    }
                  </ul>
                </div>
              </div>
            </div>
          </div>
        ) : null
      }
    </div>
  );
};

export default StudyDetail;
